
namespace Gamification.Gamification {
    export class CredenzialiColumns {
        static columnsKey = 'Gamification.Credenziali';
    }
}